<script>
  export let item
  export let base

  let placeholder = 'themes/PlayFair/img/gallery.jpg'
</script>

<div class="container pad">

  <div class="text-center intro mb-5">
    <h1>
      {#if item.title}{item.title}{:else}Gallery{/if}
    </h1>
    <p>
      {@html item.body}
    </p>
  </div>

  <div class="gallery text-center">
    {#if item.images.length > 1}
      {#each item.images as img}
        <img src={img.url} alt="gallery" />
      {/each}
    {:else}
      <img src="{base}{placeholder}" alt="placeholder" />
      <img src="{base}{placeholder}" alt="placeholder" />
      <img src="{base}{placeholder}" alt="placeholder" />
    {/if}
  </div>

  <!--
<div class="row">
<div class="col-md-4">{#if item.image}<img src="{item.image}" class="img-fluid" />{:else}<img src="themes/PlayFair/img/gallery.jpg" class="img-fluid" />{/if}</div>
<div class="col-md-4">{#if item.image}<img src="{item.image}" class="img-fluid" />{:else}<img src="themes/PlayFair/img/gallery.jpg" class="img-fluid" />{/if}</div>
<div class="col-md-4">{#if item.image}<img src="{item.image}" class="img-fluid" />{:else}<img src="themes/PlayFair/img/gallery.jpg" class="img-fluid" />{/if}</div>
</div>
-->

</div>
